/**
 * Home component.
 */

import './_home.scss';
import { ApplicationContext } from '../../common/context';
import { Button, Col, Row } from 'antd';
import React, { useContext } from 'react';

const Home = () => {
  const context = useContext(ApplicationContext);
  const pathname = window.location.href;
  const langSplit = pathname.split('=');
  const language = langSplit.length > 1 && langSplit[1] == 'en' ? 'en' : 'pt';
  const prefix = context.isMatrix ? 'matrix' : 'evaluation';
  const tab = context.tab;
  const path = `${prefix}.${tab}`;
  const gridLayoutOne = {
    lg: { offset: 2, span: 14 },
    md: { offset: 1, span: 22 },
    sm: { offset: 1, span: 22 },
    xs: { offset: 1, span: 22 }
  };
  const gridLayoutTwo = {
    lg: { offset: 0, span: 10 },
    md: { offset: 1, span: 22 },
    sm: { offset: 1, span: 22 },
    xs: { offset: 1, span: 22 }
  };

  return (
    <div className={'home'}>
      <div className={'home__wrap'}>
        <Row>
          <Col {...gridLayoutOne}>
            <h2 className={'home__subtitle'}>{context.getOption(`${path}.title`)}</h2>
            <h1 className={'home__title'}>{context.getOption(`${path}.subtitle`)}</h1>
            <Button
              className={'home__init-btn'}
              onClick={() => context.handleChangeTab('2')}
              type={'primary'}
            >
              {context.getOption(`${path}.btnLabel`)}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col {...gridLayoutTwo}>
            {context.isMatrix
            ?
              language == 'pt' ?
                <img
                  alt={'rrw'}
                  src={'rrw.svg'}
                />
              :
                <img
                  alt={'rrw'}
                  src={'rrw-en.png'}
                />
            :
            language == 'pt' ?
                <img
                  alt={'ipram'}
                  src={'ipram.svg'}
                />
              :
                <img
                  alt={'ipram'}
                  src={'ipram-en.png'}
                />
              }
          </Col>
          <Col {...gridLayoutTwo}>
            <h3 className={'home__question'}>{context.getOption(`${path}.question`)}</h3>
            <p className={'home__lead'}>{context.getOption(`${path}.lead`)}</p>
            <h3 className={'home__question'}>{context.getOption(`${path}.question2`)}</h3>
            <p className={'home__description'}>{context.getOption(`${path}.description`)}</p>
            <p className={'home__description'}>{context.getOption(`${path}.description2`)}</p>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Home;
